/* import __COLOCATED_TEMPLATE__ from './list-empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Component from '@glimmer/component';
import type ContentImportService from 'embercom/services/content-import-service';
import { inject as service } from '@ember/service';

export default class ListEmptyState extends Component {
  @service declare contentImportService: ContentImportService;

  get contentReviewSummary() {
    return this.contentImportService.aiContentReviewSummary;
  }

  get hasApprovedSuggestions() {
    if (!this.contentReviewSummary) {
      return false;
    }
    return this.contentReviewSummary.approved > 0;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Suggestions::ListEmptyState': typeof ListEmptyState;
  }
}
